import React, { useEffect, useState } from 'react';
import { COMPUTE_PERFORMANCE_BASED_BONUS, useExpenseService } from 'domain/shared/expense';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import { useListContext } from 'framework/list';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import moment from 'moment/moment';
import { DateInput } from 'framework/form';

type Props = any;

const CreateBatchExpenseAccrualCyclesButton = ({ disabledInput = false, initialValue = '', ...props }: Props) => {
  const { createBatchExpenseAccrualCycles } = useExpenseService();
  const [dateErrors, setDateErrors] = useState<string[]>([]);
  const { getToday } = useDateService();
  const { filter, reloadData = () => {} } = useListContext();

  const currentFilterValue = filter?.period?.eq;

  const currentMonth = getToday().startOf('month').subtract(1, 'month');

  const [date, setDate] = useState<any>(initialValue || currentFilterValue || currentMonth);

  const onDateChange = (values: any) => {
    setDate(values.date);
    const isValid = moment(values.date, DATE_FORMAT.API_ONLY_MONTH, true).isValid();

    if (!values.date) {
      setDateErrors(['Field is required']);
    } else if (!isValid) {
      setDateErrors(['Please, choose the correct date']);
    } else if (moment(values.date, DATE_FORMAT.API_ONLY_MONTH, true).isAfter(currentMonth)) {
      setDateErrors(['Please, choose month earlier than current month']);
    } else {
      setDateErrors([]);
    }
  };

  useEffect(() => {
    if (currentFilterValue) {
      onDateChange({ date: currentFilterValue });
    }
    if (initialValue) {
      onDateChange({ date: initialValue });
    }
    // Suppressed warnings because we only need to call useEffect callback if currentFilterValue is changed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFilterValue, initialValue]);

  return (
    <ButtonWithConfirmation
      displayMessage="Do you really want to create batch expense accrual cycles? Please, fill out the input below."
      modalChildren={
        <DateInput
          source="date"
          label="Period"
          onChangeCallback={onDateChange}
          errorMessages={dateErrors}
          isRequired
          dateFormat={DATE_FORMAT.API_ONLY_MONTH}
          value={
            date && moment(date, DATE_FORMAT.API_ONLY_MONTH, true).isValid()
              ? moment(date).format(DATE_FORMAT.API_ONLY_MONTH)
              : (date as any)
          }
          maxDate={currentMonth}
          disabled={disabledInput}
          sx={{ mt: 2.5 }}
        />
      }
      variant="outlined"
      submitMethod={() =>
        createBatchExpenseAccrualCycles({
          period: moment(date).format(DATE_FORMAT.API_ONLY_MONTH), // backend YearMonth
        })
      }
      confirmBtnProps={{ disabled: !!dateErrors.length }}
      permissionToCheck={COMPUTE_PERFORMANCE_BASED_BONUS}
      afterSubmit={{
        successMessage: 'Batch expense accrual cycles creation has been successfully started.',
        errorMessage: "Can't start batch expense accrual cycles creation.",
        execute: () => {
          reloadData();
        },
      }}
      {...props}
    >
      Create batch accrual cycles
    </ButtonWithConfirmation>
  );
};

export default CreateBatchExpenseAccrualCyclesButton;
